import { storyblokEditable } from "@storyblok/react";
import { StoryblokPicture } from "@components/core/Storyblok/StoryblokImage";

function CatalogLargeBanner({ blok }) {
  if (!blok) return null;

  return (
    <section
      key={blok._uid}
      {...storyblokEditable(blok)}
    >
      <StoryblokPicture
        className="w-100 pb-6 pb-md-7"
        desktopSrc={blok.catalog_large_banner_desktop?.filename}
        mobileSrc={blok.catalog_large_banner_mobile?.filename}
        loading="eager"
      />
    </section>
  );
}

export default CatalogLargeBanner;
